var grid = $('.js-box-grid').isotope({
  itemSelector: '.box-grid__item',
  percentPosition: true,
  layoutMode: 'packery'
  // packery: {
  //   gutter: 10
  // }
});

grid.imagesLoaded()
    .progress(function (instance, image) {
      setTimeout(function () {
        grid.isotope('layout');
      }, 250)
    })
    .fail(function (instance) {
      setTimeout(function () {
        grid.isotope('layout');
      }, 1500)
    }
  );
